import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { crabSvg, dayLook, loadPool } from '../../lib/clawdPool.js';

/* 信纸卡右上的邮票（2026-11-04）：原来是小夜窗的天空+月牙，
   铃点单换成「今天的小蟹蟹」——和月历里今天那格是同一只，点一下翻开月历。
   库没加载出来时先空着纸面，不闪原来的月牙。 */
export default function CrabStamp() {
  const nav = useNavigate();
  const [html, setHtml] = useState('');

  useEffect(() => {
    let alive = true;
    loadPool()
      .then((pool) => {
        if (alive) setHtml(crabSvg(pool, dayLook(pool), { anim: true }));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <button
      type="button"
      className="hm-letter-stamp hm-crab-stamp"
      onClick={() => nav('/calendar')}
      aria-label="今天的小蟹蟹 · 打开月历"
    >
      <span className="hm-crab-stamp-in" dangerouslySetInnerHTML={{ __html: html }} />
    </button>
  );
}
